import React from "react";

export const IconTwoFingerSlide = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlSpace="preserve" viewBox="0 0 48 60" {...props}>
    <g
      fill="none"
      stroke="#FFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="2"
    >
      <path d="M19 32V6a3 3 0 0 1 6 0v17M25 13V4a3 3 0 0 1 6 0v20M31 26v-7a3 3 0 0 1 6 0v10" />
      <path d="M37 29v-6a3 3 0 0 1 6 0v9c0 8.284-6.716 15-15 15s-15-6.716-15-15v-7c0-3.313 2.688-6 6-6M9 14l-2 2-2-2M9 5 7 3 5 5M7 3v13" />
    </g>
  </svg>
);
